module.exports = __webpack_public_path__ + "img/1.b809dc81.jpg";